<template>
  <div class="custom-dialog" :class="{ active: showDialog }">
    <transition name="custom-dialog-transition" leave-active-class="custom-dialog-slide-down">
      <div class="dialog-content" v-if="showDialog">
        <v-card class="dialog-card">
          <div class="notes-header">
            <img :src="imageSrc" alt="calendar" />
            <span class="header-text">Notes</span>
            <v-spacer></v-spacer>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </div>
          <v-divider></v-divider>
          <div class="notes-text">
            <ul v-for="note in notes" :key="note">
              <li> {{ note }}</li>
            </ul>
          </div>
          <v-card-actions>
            <v-btn block color="#0054A6" @click="onConfirm" class="button-ok">OK</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </transition>
    <div class="overlay" @click="closeDialog"></div>
  </div>
</template>
  
<script >
import exclamationMarkImg from '@/assets/exclamation-mark.png';

export default {
  name: 'NotesPopup',
  props : {
    showDialog : {
      type : Boolean,
      default : false
    }
  },
  data() {
    return {
      dialogVisible: true,
      notes: ['You can book only one token for the same day.', 'You can book an appointment on the same day or 1 day in advance.', 'You will receive a notification via SMS once your booking is successful.', 'You will need to show the successful Booking Appointment SMS when you visit to the bank. (Screenshot of SMS will not be valid)', 'If you miss three branch appointments, your booking privileges will be temporarily paused for one week'],
      imageSrc: exclamationMarkImg
    };
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },

    onConfirm() {
      this.$emit('onConfirm');
    }
  },
};
</script>
  
<style scoped>

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #000;
  border-radius: 50%;
  margin-right: 8px;
}

.v-card {
  padding: 16px;
  border-radius: 16px 16px 0 0;
}

.notes-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}

.header-text {
  width: 80%;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  margin-left: 10px;
}

.notes-text {
  font-size: 14px;
  line-height: 24px;
  margin-top: 8px;
}

.button-ok {
  color: white;
  text-transform: none;
}

.v-icon.v-icon {
  font-size: 16px;
}

.v-card {
  margin: 0;
  position: absolute !important;
  bottom: 0 !important;
  left:0;
}
.custom-dialog {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  z-index: 1000;
}

.custom-dialog.active {
  opacity: 1;
  visibility: visible;
}

.dialog-content {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 16px;
  animation: slideUp 0.6s ease-in-out;
  z-index: 1;
}

.dialog-card {
  width: 100%;
  max-height: 100%;
  border-radius: 10px 10px 0 0;
  box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 0;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

.custom-dialog-slide-down {
  animation: slideDown 0.6s ease-in-out; /* Adjust the duration here */
}

@keyframes slideDown {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}


</style>
  
  